import React from 'react';
import StorageIcon from '@mui/icons-material/Storage';
import ChatIcon from '@mui/icons-material/ChatBubbleOutline';
import BarChartIcon from '@mui/icons-material/BarChartOutlined';
import { Step } from './Step';

const steps = [
  { icon: StorageIcon, title: 'Connect BigQuery', body: 'Either host in your own GCP or we can host tables for you.' },
  { icon: ChatIcon, title: 'Ask in plain English', body: '"Which channel drove the most signups last week?" — no SQL required.' },
  { icon: BarChartIcon, title: 'Get charts + answers', body: 'The agent queries live and replies with the right chart, table, or number.' },
];

export function HowItWorks() {
  return (
    <section
      style={{
        padding: '70px 48px',
        maxWidth: 1240,
        margin: '0 auto',
        boxSizing: 'border-box',
        borderTop: '1px solid var(--border-subtle)',
      }}
    >
      <h2
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 400,
          fontSize: 'var(--text-2xl)',
          letterSpacing: 'var(--tracking-tight)',
          margin: '0 0 40px',
          textAlign: 'center',
        }}
      >
        How it works
      </h2>
      <div className="ca-steps" style={{ display: 'flex', gap: 32 }}>
        {steps.map((s) => (
          <Step key={s.title} icon={s.icon} title={s.title} body={s.body} />
        ))}
      </div>
    </section>
  );
}